import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export const reverseGeocodeSecure = (lat, lng) => httpsCallable(functions, "reverseGeocodeSecure")({
  location: { lat, lng },
}).then(response => response.data);

export const computeRouteSecure = (origin, destination) => httpsCallable(functions, "computeRouteSecure")({
  origin: { lat: origin.lat, lng: origin.lng },
  destination: { lat: destination.lat, lng: destination.lng },
}).then(response => response.data);

const routeCache = new Map();

export async function getCachedSecureRoute(origin, destination, maxAgeMs = 30000) {
  const key = [origin.lat, origin.lng, destination.lat, destination.lng].map(value => Number(value).toFixed(3)).join(",");
  const cached = routeCache.get(key);
  if (cached && Date.now() - cached.at < maxAgeMs) return cached.value;
  const value = await computeRouteSecure(origin, destination);
  routeCache.set(key, { at: Date.now(), value });
  if (routeCache.size > 20) routeCache.delete(routeCache.keys().next().value);
  return value;
}
